var React = require('react');

function ChevronArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(25,0) scale(-1,1)"},React.createElement("polygon",{"points":"14.25 8.5 14.25 16.5 10 12.5397995","fill":"currentColor"})));
}

ChevronArrowRight.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = ChevronArrowRight;

ChevronArrowRight.default = ChevronArrowRight;
